import styled from 'styled-components';

export const Error = styled.div`
  color: #e8544f;
  font-size: 0.8rem;
  font-weight: 500;
`;
